import { render, staticRenderFns } from "./agentBuyCardCostConfig.vue?vue&type=template&id=598c0dfb&scoped=true&"
import script from "./agentBuyCardCostConfig.vue?vue&type=script&lang=js&"
export * from "./agentBuyCardCostConfig.vue?vue&type=script&lang=js&"
import style0 from "./agentBuyCardCostConfig.vue?vue&type=style&index=0&id=598c0dfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598c0dfb",
  null
  
)

export default component.exports